import { IconAlertTriangle } from "@tabler/icons-react";

export default function DangerModal({
  modal_id,
  dangerDescription,
  cancel,
  confirm,
}: {
  modal_id: string;
  dangerDescription: string;
  cancel: () => void;
  confirm: () => void;
}) {
  return (
    <div className="modal modal-blur fade" id={modal_id} tabIndex={-1} role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div className="modal-content">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={cancel}
          ></button>
          <div className="modal-status bg-danger"></div>
          <div className="modal-body text-center py-4">
            <div className="flex justify-center">
              <IconAlertTriangle className="icon mb-2 text-danger icon-lg" />
            </div>
            <h3>Подтвердите действие</h3>
            <div className="text-muted">{dangerDescription}</div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-ghost-primary" data-bs-dismiss="modal" onClick={cancel}>
              Отмена
            </button>

            <button className="btn btn-danger" data-bs-dismiss="modal" onClick={confirm}>
              Подтвердить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
